import homeRouted from './signals/homeRouted';
import pageRouted from './signals/pageRouted';
import sectionRouted from './signals/sectionRouted';
import repeaterRouted from './signals/repeaterRouted';
import setAnswer from './signals/setAnswer';
import mergeAnswer from './signals/mergeAnswer';
import setNotification from './signals/setNotification';
import redirect from './signals/redirect';
import submitAnswer from './signals/submitAnswer';
import triggerFirstTime from './signals/triggerFirstTime';
import init from './signals/init';
import mailId from './signals/mailId';
import mailPdf from './signals/mailPdf';
import answerSet from './signals/answerSet';
import trackEvent from './signals/trackEvent';

export default {
    homeRouted,
    pageRouted,
    sectionRouted,
    repeaterRouted,
    setAnswer,
    mergeAnswer,
    setNotification,
    redirect,
    init,
    submitAnswer,
    triggerFirstTime,
    mailId,
    mailPdf,
    answerSet,
    trackEvent,
};



// WEBPACK FOOTER //
// ./src/store/modules/app/signals.js